import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=c4d4a3ea&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d4a3ea')) {
      api.createRecord('c4d4a3ea', component.options)
    } else {
      api.reload('c4d4a3ea', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=c4d4a3ea&", function () {
      api.rerender('c4d4a3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/comp/ImgFallback2.vue"
export default component.exports